import CommunityStats from '@/components/community-stats';

type PublicStats = {
  activeCreators?: number;
  availableClasses?: number;
  totalSessions?: number;
  totalStudents?: number;
} | null;

export default function CommunitySection({
  publicStats,
  title = 'Our Growing Community',
  subtitle = 'Join thousands of learners and talented creators in our thriving educational community.',
}: {
  publicStats: PublicStats;
  title?: string;
  subtitle?: string;
}) {
  return (
    <section className="py-16 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">{title}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{subtitle}</p>
        </div>

        <CommunityStats publicStats={publicStats} />
      </div>
    </section>
  );
}
